<template>
    <div class="text-center">
        <i class="fad fa-spinner-third fa-spin aristotle-font-awesome-duotone" />
        {{ loadingMessage }}
    </div>
</template>

<script>
// Large centered loading message with spinner
export default {
    name: "Loading",
    props: {
        loadingMessage: {
            type: String,
            default: 'Loading',
        }
    },
}
</script>

<style scoped>
div {
    font-size: 30px;
    width: 10%;
    margin-left: auto;
    margin-right: auto;
}
</style>
